import React, { useMemo } from 'react'

//@ts-ignore
import styles from '../style.module.css'

import { cx } from '@emotion/css';
import { ReactEditor, useFocused, useSelected } from 'slate-react';
import { EmbedBtnGrp } from '..'
import { Transforms } from 'slate';


export const ReferenceComponent = ({ content_type_uid, attributes, children, type, entry, handleEdit, handleDelete, editor }) => {
  const selected = useSelected();
  const focused = useFocused();
  const highlight = selected && focused;
  const isError = entry['error'];
  const publish_details = entry['publish_details'];
  const isDisabled = entry['disable'];
  const isPublished = useMemo(() => publish_details && publish_details.every(env => env['version'] === entry['_version']), [publish_details]);

  const path = ReactEditor.findPath(editor, attributes.element)
  const handleClick = () => {
    Transforms.select(editor, path)
  }
  return (
    <span onClick={handleClick} data-type={type} className={cx(styles['embed'], styles[`embed--${type}`], highlight && styles['embed--active'], isError && styles['embed--error'], styles[isPublished ? 'embed--published' : 'embed--draft'], isDisabled && styles['embed--disabled'])} >
      <span className={styles['embed--title']} contentEditable={false}>
        <span>{entry['title']}</span>
      </span>
      {type === 'block' && <span contentEditable={false} className={styles['embed--content_type_uid']}>{isDisabled ? "Content type Title" : content_type_uid}</span>}
      <div contentEditable={false} className={styles['embed--btn-group']}>
        <EmbedBtnGrp isDisabled={isDisabled} isError={isError} handleCaption={undefined} type={undefined} handleDelete={handleDelete} handleEdit={handleEdit} editor={editor} attributes={attributes} handleUnlink={undefined} error={entry['error']} />
      </div>
      <span {...attributes} >{children}</span>
    </span>
  )
}